// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__NPnIf","certainties":"style_certainties__cfzhm","certain":"style_certain__ltqG1","switch":"style_switch__BnolO"};